/* eslint-disable */
import React, { useState, useContext } from 'react';
import { AuthContext } from '../../auth/AuthContext';
import { signIn } from '../../services/login';
import logo from '../../assets/Logo-NEXT-Business-positivo.svg';

import {
    Card,
    CardHeader,
    CardBody,
    CardActions
} from '@progress/kendo-react-layout';

import { Input } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons';
import { Label } from '@progress/kendo-react-labels';

import './styles.css';

export default function Auth() {
    const { setUser } = useContext(AuthContext);
    const [form, setForm] = useState({ Email: '', Senha: '' });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setError('');
            setLoading(true);
            await signIn(form, setUser);
        } catch {
            setError('Usuário ou senha inválidos');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-bg">
            <Card className="auth-card">
                <CardHeader className="auth-header">
                    <img src={logo} alt="Logo" className="auth-logo" />
                </CardHeader>

                <CardBody>
                    <form onSubmit={handleSubmit} className="auth-form">

                        <div className="auth-input">
                            <Label>E-mail</Label>
                            <Input
                                name="Email"
                                value={form.Email}
                                onChange={handleChange}
                                autoComplete="off"
                            />
                        </div>

                        <div className="auth-input">
                            <Label>Senha</Label>
                            <Input
                                type="password"
                                name="Senha"
                                value={form.Senha}
                                onChange={handleChange}
                                autoComplete="off"
                            />
                        </div>

                        {error && <p className="auth-error">{error}</p>}

                        <CardActions>
                            <Button
                                type="submit"
                                disabled={loading}
                                className="auth-btn"
                            >
                                {loading ? 'Entrando...' : 'Entrar'}
                            </Button>
                        </CardActions>
                    </form>
                </CardBody>
            </Card>
        </div>
    );
}
